// extracted by mini-css-extract-plugin
export default {"user-link":"_2yXGz","userLink":"_2yXGz","link-banned":"_30SAY","linkBanned":"_30SAY"};